import moment from 'moment';

export const utcToDate = (dateNumber: number) => {
  const timestamp = dateNumber * 1000;
  const date = new Date(timestamp);
  return date.toLocaleDateString();
};

export const formatDate = (date: string) => {
  const formattedDate = new Date(date).toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  return formattedDate;
};
export const formatStringToDate = (inputString: string): string => {
  if (!inputString.length) {
    return '';
  }
  const dateObject = new Date(inputString);

  const year = dateObject.getFullYear();
  const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
  const day = dateObject.getDate().toString().padStart(2, '0');
  const hours = String(dateObject.getHours()).padStart(2, '0');
  const minutes = String(dateObject.getMinutes()).padStart(2, '0');

  const formattedDate = `${year}/${month}/${day}, ${hours}:${minutes}`;
  return formattedDate;
};

export const utcToBrowserDate = (date: number | string, format?: string) => {
  if (!date) {
    return '-';
  }
  return moment
    .utc(date)
    .local()
    .format(format ?? 'YYYY-MM-DD hh:mm A');
};
